<div
  class="w-full flex justify-center items-center bg-cover bg-bottom bg-no-repeat bg-[url('/assets/images/Group_69.webp')] h-[230px] sm:h-[180px] relative px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="absolute inset-0 bg-black opacity-80"></div>
  <div
    class="container mx-auto relative z-10 flex items-center xl:justify-between w-full px-4"
  >
    <button
      routerLink="/account/listing/{{ listingId }}"
      type="button"
      class="flex items-center text-white cursor-pointer hidden xl:block"
    >
      <span class="mr-2">&larr;</span>
      <span>Account</span>
    </button>

    <div class="text-center flex flex-col items-center justify-center flex-1">
      <h1 class="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white">
        Make changes to your listing
      </h1>
      <p
        class="mt-2 text-white text-[calc(14px_+_(400vw_-_1280px)_/_1360)] xl:text-[18px]"
      >
        You are requesting changes to your ad {{ listingYear }}
        {{ listingModel }} {{ listingTrim }} {{ listingColour }}.
      </p>
    </div>
    <div class="w-[90px] hidden xl:block"></div>
  </div>
</div>

<!-- Alert Component -->
 <div class="px-3 md:px-5 2xl:px-28 3xl:px-52">
   <div class="container mx-auto">
     <div class="my-10 text-gray-900 p-5 rounded-lg flex gap-3">
       <div>
         <h5 class="text-gray-900 font-medium mb-1">
           What changes do you want to make to your listing?
         </h5>
         <p class="text-gray-700">
           Please complete the below form to request for changes to listing
           information, price of your Tesla, add/remove images and purchase
           additional services such bump or social media promotion.
         </p>
       </div>
     </div>
   </div>
 </div>

 <div class="px-3 md:px-5 2xl:px-28 3xl:px-52">
   <div class="container mx-auto pb-10">
     <div class="bg-white rounded-lg shadow p-6">
       <form [formGroup]="requestForm" (ngSubmit)="onSubmit()" class="space-y-6">
         <!-- Request Type Pills -->
         <!--  <div class="space-y-2">
           <label
             for="request-types"
             class="block font-medium text-gray-700 mb-10"
           >
             What would you like to change?
           </label>

           <div id="request-types" class="flex flex-col gap-2">
             <label
               *ngFor="let type of requestTypes"
               class="flex gap-3 items-start justify-start mb-3"
               [class.text-blue-700]="selectedRequests.has(type.id)"
               [class.!border-blue-700]="selectedRequests.has(type.id)"
             >
               <input
                 type="radio"
                 name="requestType"
                 formControlName="requestType"
                 [checked]="selectedRequests.has(type.id)"
                 [value]="type.id"
                 (change)="toggleRequest(type.id)"
                 class="size-4"
               />
               <div class="flex flex-col -mt-1">
                 <span> {{ type.label }} <span *ngIf="type.paid" class="text-xs bg-blue-600 rounded-full px-2 text-white py-0.5">paid</span></span>
                 <span class="text-sm opacity-80">{{ type.desc }}</span>
               </div>
             </label>
           </div>

           <p
             *ngIf="selectedRequests.size === 0"
             class="text-sm text-red-600 mt-1"
           >
             Please select at least one change type
           </p>
         </div> -->

         <!-- Subject (Auto-generated) -->
         <!-- <div>
           <label
             for="subject"
             class="block text-sm font-medium text-gray-700 mb-2"
             >Request Summary</label
           >
           <input
             id="subject"
             type="text"
             formControlName="subject"
             class="w-full px-4 py-2 border rounded-md bg-gray-50 text-gray-700"
             readonly
           />
         </div> -->

         <!-- Description -->
         <div>
           <label
             for="description"
             class="block text-sm font-medium text-gray-700 mb-2"
           >
             Additional Details
             <span class="text-red-600">*</span>
           </label>
           <textarea
             id="description"
             formControlName="description"
             rows="6"
             class="w-full px-4 py-2 border rounded-md resize-none focus:outline-OUT-Blue"
             placeholder="Please provide full details of your changes here"
           ></textarea>
           <div
             *ngIf="
               requestForm.get('description')?.touched &&
               requestForm.get('description')?.invalid
             "
             class="mt-0.5 text-sm text-red-600"
           >
             Minimum 10 characters required
           </div>
         </div>
         <!-- Submit Button -->
         <button
           type="submit"
           [disabled]="requestForm.invalid || isSubmitting"
           class="w-full px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center gap-2 lg:w-1/2 cursor-pointer"
         >
           <span
             *ngIf="isSubmitting"
             class="w-full flex justify-center items-center gap-3"
           >
             <svg
               class="size-6 animate-spin"
               xmlns="http://www.w3.org/2000/svg"
               fill="none"
               viewBox="0 0 24 24"
             >
               <circle
                 class="opacity-25"
                 cx="12"
                 cy="12"
                 r="10"
                 stroke="currentColor"
                 stroke-width="4"
               />
               <path
                 class="opacity-75"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="4"
                 stroke-linecap="round"
                 d="M12 2a10 10 0 0 1 0 20"
               />
             </svg>
             Submitting...
           </span>
           <span *ngIf="!isSubmitting">Submit Request</span>
         </button>
       </form>
     </div>
   </div>
 </div>

<out-alert></out-alert>
